export default __webpack_public_path__ + "static/media/second.b3f43bfb.gif";